<template>
    <div class="fixed inset-0 flex z-40" v-show="open">
        <transition
            enter-active-class="transition-opacity ease-linear duration-300"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition-opacity ease-linear duration-300"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div class="fixed inset-0" v-if="open">
                <div class="absolute inset-0 bg-gray-600 opacity-75"></div>
            </div>
        </transition>

        <transition
            enter-active-class="transition ease-in-out duration-300 transform"
            enter-from-class="-translate-x-full"
            enter-to-class="translate-x-0"
            leave-active-class="transition ease-in-out duration-300 transform"
            leave-from-class="translate-x-0"
            leave-to-class="-translate-x-full"
        >
            <div class="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-gray-800" v-show="open">
                <div class="absolute top-0 right-0 -mr-14 p-1">
                    <button
                        @click="open = false"
                        class="flex items-center justify-center h-12 w-12 rounded-full focus:outline-none focus:bg-gray-600"
                        aria-label="Close sidebar"
                    >
                        <svg class="h-6 w-6 text-white" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                </div>
                <div class="shrink-0 flex items-center px-4">
                    <a href="/">
                        <img class="h-8 w-auto" src="/svg/logo.svg" alt="Tichit logo" />
                    </a>
                </div>
                <div class="mt-5 flex-1 h-0 overflow-y-auto">
                    <nav class="px-2">
                        <slot name="items"></slot>
                    </nav>
                </div>
            </div>
        </transition>
        <div class="shrink-0 w-14">
            <!-- Dummy element to force sidebar to shrink to fit close icon -->
        </div>
    </div>
</template>

<script setup>
import { onBeforeMount, onMounted } from 'vue';
import { useMobileSidebar } from '@/composables/mobileSidebar.js';

const { open, close } = useMobileSidebar();

function onEscape(e) {
    if (e.key === 'Esc' || e.key === 'Escape') {
        close();
    }
}

onMounted(() => {
    document.addEventListener('keydown', onEscape);
});
onBeforeMount(() => {
    document.removeEventListener('keydown', onEscape);
});
</script>
